import { render, staticRenderFns } from "./CoozzyFileExportIcon.vue?vue&type=template&id=d881f1ba&scoped=true"
import script from "./CoozzyFileExportIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyFileExportIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyFileExportIcon.vue?vue&type=style&index=0&id=d881f1ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d881f1ba",
  null
  
)

export default component.exports